module.exports = __webpack_public_path__ + "020e988e8af296d6914825083d4f4bb6.png";